let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kxPXV")).then(() => parcelRequire('4suLn'));